import { Button, Typography } from '@analytical-alley/ui';
import { HiRefresh } from 'react-icons/hi';
import React from 'react';

interface Props {
    isDirty: boolean;
    onClick: () => void;
}

export function Header({ isDirty, onClick }: Props) {
    return (
        <div className="flex justify-between items-center py-4 px-6 border-b border-white/5 bg-white/2 rounded-t-2xl">
            <Typography
                variant="titleM"
                className="text-white font-bold tracking-tight"
                tooltip="Pick your KPI type, target and either set the specific budget for a particular channel, or let our smart optimiser pick the best channel budget for you."
            >
                Control Panel
            </Typography>
            <div className="flex gap-2">
                {isDirty && (
                    <Button
                        color="glass"
                        size="sm"
                        onClick={onClick}
                        tooltip="Return to default values"
                        className="rounded-lg flex items-center justify-center border border-white/10 hover:bg-white/10 transition-all text-xs"
                    >
                        <HiRefresh className="w-4 h-4 mr-1.5 opacity-70" />
                        Reset Changes
                    </Button>
                )}
            </div>
        </div>
    );
}
